/** localStorage draft for second brand when Q2 = Yes on /survey/prevbrandanswer. */
export const OTHER_PREV_BRAND_STORAGE_KEY = 'ldsurvey:otherPrevBrand';

export type OtherPrevBrandAnswers = {
  brand: string;
  variant: string;
};

export function readOtherPrevBrandAnswers(): Partial<OtherPrevBrandAnswers> | null {
  try {
    const raw = localStorage.getItem(OTHER_PREV_BRAND_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (typeof parsed !== 'object' || parsed === null) return null;
    const p = parsed as Record<string, unknown>;
    return {
      brand: typeof p.brand === 'string' ? p.brand : '',
      variant: typeof p.variant === 'string' ? p.variant : '',
    };
  } catch {
    return null;
  }
}

export function writeOtherPrevBrandAnswers(data: OtherPrevBrandAnswers): void {
  try {
    localStorage.setItem(OTHER_PREV_BRAND_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearOtherPrevBrandAnswers(): void {
  try {
    localStorage.removeItem(OTHER_PREV_BRAND_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isOtherPrevBrandComplete(): boolean {
  const s = readOtherPrevBrandAnswers();
  return !!s?.brand?.trim() && !!s?.variant?.trim();
}
